export class ApiUnauthorizedError extends Error {
  constructor(message = 'Unauthorized') {
    super(message);
    this.name = 'ApiUnauthorizedError';
  }
}

export class ApiHttpError extends Error {
  status: number;
  code?: string;
  traceId?: string;
  url?: string;
  method?: string;

  constructor(
    status: number,
    message?: string,
    code?: string,
    traceId?: string,
    url?: string,
    method?: string,
  ) {
    super(message ?? `HTTP ${status}`);
    this.name = 'ApiHttpError';
    this.status = status;
    this.code = code;
    this.traceId = traceId;
    this.url = url;
    this.method = method;
  }
}
